import { Text } from '@chakra-ui/react';
import { OutlineCard } from '@morressier/alembic';

const AffiliationNotFound = () => {
  return (
    <OutlineCard borderless width="100%" paddingY={1} paddingX={4}>
      <Text marginTop={2} textStyle={'textBody'} marginBottom={2}>
        No affiliations have been added to this profile yet
      </Text>
    </OutlineCard>
  );
};

export default AffiliationNotFound;
